/**
 * 加密解密工具类
 * 先从原有项目中考过了
 */
import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import { mattsPublicKeyString } from 'core/config'

let self = {}

//AES key
self.RANDOMKEY = ''
//AES 向量
self.RANDOMIV = ''
/**
 * RSA加密，
 * 使用RSA公钥加密并做Base64编码
 * _str： 需要加密的字符串
 * **/
self.encrypt = (_str) => {
  //实例化加密对象
  let encrypt = new JSEncrypt()
  //设置加密公钥
  encrypt.setPublicKey(mattsPublicKeyString)

  return encrypt.encrypt(_str)
}

/**
 * AES加密
 * params: 加密参数
 * key: 16位秘钥
 * iv：16位秘钥向量
 * **/
self.encryptAES = (params, key, iv) => {
  params = JSON.stringify(params)
  let data = CryptoJS.enc.Utf8.parse(params)
  key = CryptoJS.enc.Utf8.parse(self.RANDOMKEY)
  iv = CryptoJS.enc.Utf8.parse(self.RANDOMIV)

  //后端采用CBC/Pkcs7
  let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })

  return encrypted.toString()
}

/**
 * AES解密
 * params: 加密参数
 * key: 16位秘钥
 * iv：16位秘钥向量
 * **/
self.decryptedAES = (params, key, iv) => {
  key = CryptoJS.enc.Utf8.parse(self.RANDOMKEY)
  iv = CryptoJS.enc.Utf8.parse(self.RANDOMIV)

  //后端采用CBC/Pkcs7
  let decrypt = CryptoJS.AES.decrypt(params, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)

  return decryptedStr.toString()
}

/**
 * HmacSHA256 签名运算
 * 需要加密的接口都需要使用签名运算
 * secretKey: 签名的Key, 从后端接口获取
 * params: 需要签名的参数，
 * 参数按照ASCII码的顺序对参数名进行排序(使用 UTF-8 编码，且进行了 URI 编码，十六进制字符必须大写，如‘:'会被编码为'%3A'，空格被编码为'%20')。
 * 接口：http://10.0.1.31:3000/project/19/interface/api/65857
 * **/
self.hmacSHA256 = (secretKey, params) => {
  // 有些字符encodeURIComponent编码不了，用正则手动替换
  /*  params = params.replace(/!/g, '%21')
                  .replace(/\^/g, '%5E')
                  .replace(/\)/g, '%29')
                  .replace(/\(/g, '%28')
                  .replace(/~/g, '%7E')
                  .replace(/{/g, '%7B')
                  .replace(/}/g, '%7D')
                  .replace(/>/g, '%3E')
                  .replace(/</g, '%3C')*/

  let hash = CryptoJS.HmacSHA256(params, secretKey)
  let hashInBash64 = CryptoJS.enc.Base64.stringify(hash)

  return hashInBash64
}

/**
 * json按照ASCII排序
 * obj: 要排序的json对象
 * **/
self.sortASCII = (obj) => {
  return removeNullKey(obj)
}

/**
 * 去掉对象中的null和undefined值
 * **/
let removeNullKey = (obj) => {
  if (typeof obj !== 'object') return

  for (let key in obj) {
    if (typeof obj[key] === 'undefined' || obj[key] === null) {
      delete obj[key]
    }
    if (typeof obj[key] === 'object') {
      //递归去null，undefined
      removeNullKey(obj[key])
    }
  }

  return sort(obj)
}

/**
 * json按照ASCII排序
 * **/
let sort = (obj) => {
  let arr = new Array()
  let num = 0
  for (let i in obj) {
    arr[num] = i
    num++
  }
  let sortArr = arr.sort()
  let sortObj = {}
  for (let i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]]
  }

  return sortObj
}

/**
 *  随机(大小写+数字)字符串
 *  默认16位，len: 位数
 * **/
self.len16Str = (len) => {
  len = len || 16
  //默认取消了容易混淆的字符oOLl,9gq,Vv,Uu,I1
  let $chars = 'ABCDEFJHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let maxPos = $chars.length
  let str = ''
  for (let i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos))
  }

  return str
}

self.RANDOMKEY = self.len16Str()
self.RANDOMIV = self.len16Str()

export default self
